// extracted by mini-css-extract-plugin
export var cardIcon = "_7z-5";
export var checkboxCard = "_7z-0";
export var checkboxCardSelected = "_7z-4";
export var disabled = "_7z-2";
export var interactive = "_7z-1";
export var outerBorder = "_7z-3";
export var spacerMedium = "_7z-8";
export var spacerSmall = "_7z-7";
export var spacerXsmall = "_7z-6";